<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['saving_scheme']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <router-link :to="{ path: '/profile',  query: { id: data.item.patient_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-square-edit-outline"></i> Ledger</router-link>
                  </div>
                </template>
                </b-table>
                <span class="total-label">Total Spent:</span>
                <span class="total-value">{{ commas(totalSpent) }}</span>

                <span class="total-label">Total Savings:</span>
                <span class="total-value">{{ commas(totalSavings) }}</span>

                <span class="total-label">Total Balance:</span>
                <span class="total-value">{{ commas(totalBalance) }}</span>


              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients Balances</span></center>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="view-visit" centered title="View Patient Visit" title-class="font-14" hide-footer>
      <h6 class="text-dark"> Name : <span class="text-primary">{{ name }}</span>
       Gender : <span class="text-primary">{{ gender }}</span>
       Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
      <table class="table table-sm mt-2" style="color: black;" density="compact">
      <thead><tr><th>Service Category</th><th>Service Name</th><th>Price</th></tr></thead>
        <tbody>
        <tr v-for="item in services" :key="item.id">
            <td>{{ item.service_category.name }}</td>
            <td>{{ item.service_name.name }}</td>
            <td>{{ item.service_price }}</td>
            </tr>
        </tbody>
      </table>
      <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-visit')" >Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientbalanceMethods, patientbalanceComputed } from "@/state/helpers";

export default {
  page: {
    title: "Account Balances",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Account Balances",
      items: [ {text: "Dashboard",to: "/",}, {text: "Account Balances",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'patient_id', label: 'Patient ID', visible: true },
          { key: 'name', label: 'Name', visible: true },
          { key: 'savings', label: 'Savings', visible: true },
          { key: 'spent', label: 'Spent', visible: true },
          { key: 'balance', label: 'Balance', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
    };
  },
  computed: {
    ...patientbalanceComputed,
    List() { return this.patientbalances.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patientbalances.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.patientbalances.length>0) { a=false;} else { a=true;} return a },
    totalSpent() { return this.Items.reduce((total, item) => total + Number(item.spent), 0);  },
    totalSavings() { return this.Items.reduce((total, item) => total + Number(item.savings), 0);  },
    totalBalance() { return this.Items.reduce((total, item) => total + item.balance, 0); },
  },
  mounted() {
    this.fetchBalances();
    this.TotalRows = this.patientbalances.length;
    this.isBusy=false;
  },
  methods: {
    ...patientbalanceMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style scoped>
.total-label {
  margin-right: 10px; 
}
.total-value {
  font-weight: bold;
  margin-right: 20px; 
}
</style>